import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useT } from '../i18n';
import { useProductTexts } from '../utils/productI18n';

const Breadcrumb = () => {
  const t = useT('breadcrumb');
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  // Le produit entier (et non son seul titre) : le titre affiché est traduit au rendu (repli : français).
  const [product, setProduct] = useState(null);
  const tp = useProductTexts();
  const productName = product ? tp(product).titre : '';
  const [mainCategory, setMainCategory] = useState({ name: '', slug: '' });

  useEffect(() => {
  const lastPath = pathnames[pathnames.length - 1];
  // Charger le produit si on est sur une page produit (par URL, pas par ID)
  if (lastPath && pathnames[0] === 'produit') {
    axios.get('https://joli-mot.fr/api-2026.php', {
      params: { 
        cleApi: '34KVHFQSP226YTk4n256QP6rGbqhA5w2ymY7W3pLwdbuc3i75',
        service: 'getProductByUrl',
        url: lastPath
      }
    })
      .then(response => {
        if (response.data && response.data.data) {
          const productData = response.data.data;
          if (productData) {
            setProduct(productData);
            // Pour l'instant, on simplifie la catégorie car on n'a que l'ID
            if (productData.category_id) {
              setMainCategory({
                name: t('breadcrumb.category', { id: productData.category_id }), // À améliorer avec une jointure
                slug: productData.category_id,
              });
            }
          }
        } else {
          console.error('Aucune donnée trouvée');
        }
      })
      .catch(error => {
        console.error('Erreur lors du chargement du produit:', error.response ? error.response.data : error.message);
      });
  }
// Dépendance sur location.pathname (chaîne stable) et non sur `pathnames` : ce tableau est
// recréé à chaque rendu (.split().filter()), ce qui redéclenchait cet effet en boucle infinie
// (constaté le 2026-09-18 en testant une fiche produit en local — touchait déjà toutes les
// fiches produit, y compris en prod, sans erreur visible car silencieux en arrière-plan).
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [location.pathname]);


  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: "15px", paddingBottom: 0 }}>
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/" style={{ textDecoration: 'none', color: '#c48f8b' }}>
          {t('breadcrumb.home')}
        </Link>
        {mainCategory.name && (
          <Link to={`/category/${mainCategory.slug}`} style={{ textDecoration: 'none', color: '#c48f8b' }}>
            {mainCategory.name}
          </Link>
        )}
        {productName && (
          <Typography color="textPrimary">
            {productName}
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
